angular.module('jobboard', ['PortalControllers','sodCommon', 'portal-common']);
